import constants from "src/api/constants";
import { ClientLogPayload } from "./interface";

const CLIENT_LOG_TIMEOUT_MS = 5000;

export const postClientLog = async (
  payload: ClientLogPayload
): Promise<void> => {
  let timer: ReturnType<typeof setTimeout> | undefined;
  try {
    const base = constants.DOT_NET_API_BASE_URL;
    if (!base) return;

    const controller = new AbortController();
    timer = setTimeout(() => controller.abort(), CLIENT_LOG_TIMEOUT_MS);

    await fetch(`${base}v1/sp/clientlogs`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
      keepalive: true,
      signal: controller.signal
    });
  } catch {
    /* Logging must never affect the user session. */
  } finally {
    if (timer) clearTimeout(timer);
  }
};
